import { Box, Typography, TypographyProps } from '@mui/material';
import { ReactNode } from 'react';

import NotCollectedText from '@/components/elements/NotCollectedText';
import { hasMeaningfulValue } from '@/modules/form/util/formUtil';

interface Props {
  children: ReactNode | string | null | undefined;
  title: ReactNode;
  sx?: TypographyProps['sx'];
  variant?: TypographyProps['variant'];
  component?: TypographyProps['component'];
  horizontal?: boolean;
}

export const CommonLabeledTextBlock: React.FC<Props> = ({
  title,
  children,
  variant = 'body2',
  component = 'div',
  sx,
  horizontal = false,
}) => (
  <Typography
    sx={{
      display: horizontal ? 'flex' : undefined,
      gap: horizontal ? 1 : undefined,
      ...sx,
    }}
    variant={variant}
    component={component}
  >
    <Box sx={({ typography }) => ({ fontWeight: typography.fontWeightBold })}>
      {title}
    </Box>
    <Box sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
      {hasMeaningfulValue(children) ? (
        children
      ) : (
        <NotCollectedText variant={variant} />
      )}
    </Box>
  </Typography>
);
